import React from 'react';
import { Outlet } from 'react-router-dom';
import AdminLayout from './AdminLayout';

/**
 * Wrapper component that provides AdminLayout once for all admin routes
 * This prevents the sidebar from re-rendering on every page change
 */
const AdminLayoutWrapper = () => {
  return (
    <AdminLayout>
      <Outlet />
    </AdminLayout>
  );
};

export default AdminLayoutWrapper;
